import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import deletePeriod from './deletePeriod';

export default (uuid, projectId) => (dispatch) => {
    const dataAlert = {
        confirmText: i18next.t('Delete'),
        haveTextCaptcha: true,
        messages: [
            i18next.t(
                'Are you sure you want to delete this period? It could compromise the integrity of your reports, potentially rendering them unusable. Consider the impact on historical analysis before proceeding',
            ),
        ],
        onSuccess: () => dispatch(deletePeriod(uuid, projectId)),
        textToValidate: i18next.t('Delete').toUpperCase(),
        title: i18next.t('Delete'),
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'warning',
    };

    dispatch(alerts.actions.show(dataAlert));
};
